const ALBUM = 'album';
const SINGLE = 'single';
const EP = 'ep';
const BOOTLEG = 'bootleg';
const UNRELEASED = 'unreleased';
const LIVE_IN_STUDIO = 'live_in_studio';
const SELF_RELEASED = 'self_released';
const NOT_AVAILABLE = 'not_available';
const LABEL = 'label';
const PLAYED_AT = 'played_at';
const QUEUED = 'queued';
const PUBLISHED = 'published';
const APPROVED = 'approved';
const REJECTED = 'rejected';
const PENDING = 'pending';
const FEATURE = 'feature';
const THEME = 'theme';
const BACKGROUND = 'background';
const ANY_STAFF = 'any_staff';
const ANY_HOSTS = 'any_hosts';
const ONLY_ME = 'only_me';
const COMMENT_VISIBILITIES = [ANY_STAFF, ANY_HOSTS, ONLY_ME];
const RELEASE_TYPES = [ALBUM, SINGLE, EP, UNRELEASED, LIVE_IN_STUDIO];
const RELEASE_TYPES_SELECT_OPTIONS = [
  {
    name: 'Album',
    value: ALBUM,
  },
  {
    name: 'Single',
    value: SINGLE,
  },
  {
    name: 'EP',
    value: EP,
  },
  {
    name: 'Live In Studio',
    value: LIVE_IN_STUDIO,
  },
  {
    name: 'Unreleased',
    value: UNRELEASED,
  },
];
const LABEL_TYPES_SELECT_OPTIONS = [
  {
    name: 'Label',
    value: LABEL,
  },
  {
    name: 'Self-Released',
    value: SELF_RELEASED,
  },
  {
    name: 'Not Available',
    value: NOT_AVAILABLE,
  },
];
const TRACK = 'track';
const TRAFFIC = 'traffic';
const NOTE = 'note';
const SUPER_ADMIN = 'super_admin';
const STATION_ADMIN = 'station_admin';
const STATION_MEMBER = 'station_member';
const SHOW_HOST = 'show_host';
const SHOW_COHOST = 'show_cohost';
const SHOW_GUEST_HOST = 'show_guest_host';
const NO_LINK = 'no_link';
const LEARN_MORE = 'learn_more';

var constants = {
  ALBUM,
  SINGLE,
  EP,
  BOOTLEG,
  UNRELEASED,
  LIVE_IN_STUDIO,
  SELF_RELEASED,
  NOT_AVAILABLE,
  LABEL,
  PLAYED_AT,
  QUEUED,
  PUBLISHED,
  APPROVED,
  REJECTED,
  PENDING,
  FEATURE,
  THEME,
  BACKGROUND,
  ANY_STAFF,
  ANY_HOSTS,
  ONLY_ME,
  COMMENT_VISIBILITIES,
  RELEASE_TYPES,
  RELEASE_TYPES_SELECT_OPTIONS,
  LABEL_TYPES_SELECT_OPTIONS,
  TRACK,
  TRAFFIC,
  NOTE,
  SUPER_ADMIN,
  STATION_ADMIN,
  STATION_MEMBER,
  SHOW_HOST,
  SHOW_COHOST,
  SHOW_GUEST_HOST,
  NO_LINK,
  LEARN_MORE,
};

export {
  ALBUM,
  ANY_HOSTS,
  ANY_STAFF,
  APPROVED,
  BACKGROUND,
  BOOTLEG,
  COMMENT_VISIBILITIES,
  EP,
  FEATURE,
  LABEL,
  LABEL_TYPES_SELECT_OPTIONS,
  LEARN_MORE,
  LIVE_IN_STUDIO,
  NOTE,
  NOT_AVAILABLE,
  NO_LINK,
  ONLY_ME,
  PENDING,
  PLAYED_AT,
  PUBLISHED,
  QUEUED,
  REJECTED,
  RELEASE_TYPES,
  RELEASE_TYPES_SELECT_OPTIONS,
  SELF_RELEASED,
  SHOW_COHOST,
  SHOW_GUEST_HOST,
  SHOW_HOST,
  SINGLE,
  STATION_ADMIN,
  STATION_MEMBER,
  SUPER_ADMIN,
  THEME,
  TRACK,
  TRAFFIC,
  UNRELEASED,
  constants as default,
};
